import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: 'p-editor',
  standalone: true
})
export class EditorSpellcheckDirective implements AfterViewInit {
  private el = inject(ElementRef);

  ngAfterViewInit(): void {
    // Quill sets spellcheck="false" on .ql-editor by default.
    // Run after the current microtask queue so Quill has finished initializing.
    setTimeout(() => {
      const qlEditor: HTMLElement | null = this.el.nativeElement.querySelector('.ql-editor');
      if (qlEditor) {
        qlEditor.setAttribute('spellcheck', 'true');
      }
    }, 0);
  }
}
